module.exports = __webpack_public_path__ + "static/media/front.a4d7b9c8.jpg";